import { Abbreviation } from "../Abbreviaton";
import { t } from "i18next";

interface AbbreviationsProps {
  hasChurchTax: boolean;
  hasSolidarityContribution: boolean;
}

export const TaxAbbreviations = (props: AbbreviationsProps) => {
  return (
    <span>
      <AbbreviationLohnsteuer />
      {props.hasChurchTax && <AbbreviationKirchensteuer />}
      {props.hasSolidarityContribution && <AbbreviationSolidaritaetszuschlag />}
    </span>
  );
};

const AbbreviationLohnsteuer = () => <Abbreviation short="LSt" long={t("calculationDetails.feesAndTaxes.LSt")} />;
const AbbreviationKirchensteuer = () => (
  <Abbreviation short="KiSt" long={t("calculationDetails.feesAndTaxes.KiSt")} addComma />
);
const AbbreviationSolidaritaetszuschlag = () => (
  <Abbreviation short="SoIZ" long={t("calculationDetails.feesAndTaxes.SoIZ")} addComma />
);
